module.exports = __webpack_public_path__ + "media/images/earth-water-4d1be7fcc6830f45e8a607c809e26d4c.png";